import { Fragment } from 'react';

// Render a note string, converting **bold** segments into <strong>. Everything else is
// plain text. Uses React text nodes (no dangerouslySetInnerHTML) so content is escaped —
// the only markup understood is the literal **double asterisks**. Safe against injection.
export function renderNote(text) {
  if (!text) return null;
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    const m = /^\*\*([^*]+)\*\*$/.exec(p);
    return m ? <strong key={i}>{m[1]}</strong> : <Fragment key={i}>{p}</Fragment>;
  });
}
